module.exports = __webpack_public_path__ + "img/loading.be00fc4a.svg";